import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import {APIService} from '@/services/APIService';

export class Board_APIService extends APIService {
    constructor(api_base_url, is_dummy = false) {
        super(api_base_url);
        // this.is_dummy = true;
    }
    getBoardExperimentStart(experiment, equipment_id){
        var self = this;
        const url = `${this.api_base_url}/api/experiment/getBoardExperimentStart.php`;
        var dummy_response = {
            value:[
            ]
        };
        if(self.is_dummy){
            return new Promise(function(resolve){setTimeout(function(){resolve(dummy_response)},1000);});
        }else{
            
            return axios.get(url, {
                params: {
                    experiment: experiment,
                    equipment_id: equipment_id,
                }
            }).then(response => response.data);
        }
    }
    getBoardExperimentLight(experiment, equipment_id){
        var self = this;
        const url = `${this.api_base_url}/api/experiment/boardGetLightStatus.php`;
        
        var dummy_response = {
            value:[
            ]
        };
        if(self.is_dummy){
            return new Promise(function(resolve){setTimeout(function(){resolve(dummy_response)},1000);});
        }else{
            
            return axios.get(url, {
                params: {
                    experiment: experiment,
                    equipment_id: equipment_id,
                }
            }).then(response => response.data);
        }
    }
    getCondition(experiment, equipment_id){
        var self = this;
        const url = `${this.api_base_url}/api/experiment/getCondition.php`;
        var dummy_response = {
            value:[
            ]
        };
        if(self.is_dummy){
            return new Promise(function(resolve){setTimeout(function(){resolve(dummy_response)},1000);});
        }else{
            
            return axios.get(url, {
                params: {
                    experiment: experiment,
                    equipment_id: equipment_id,
                }
            }).then(response => response.data);
        }
    }
    getDashboardConfig(experiment, equipment_id){
        var self = this;
        const url = `${this.api_base_url}/api/board/getDashboardConfig.php`;
        var dummy_response = {
            value:[
            ]
        };
        if(self.is_dummy){
            return new Promise(function(resolve){setTimeout(function(){resolve(dummy_response)},1000);});
        }else{
            
            return axios.get(url, {
                params: {
                    experiment: experiment,
                    equipment_id: equipment_id,
                }
            }).then(response => response.data);
        }
    }
}
